import {
  ORIENTATION_RIGHT_TO_LEFT,
  ORIENTATION_BOTTOM_TO_TOP,
  ORIENTATION_LEFT_TO_RIGHT,
  ORIENTATION_TOP_TO_BOTTOM,
} from '@Components/D3Tree/constants';

export const ZOOM_ONE = 1;
export const ZOOM_MIN = 0.125;
export const ZOOM_MAX = 2.5;
export const ZOOM_STEP = 0.1;
export const ORIENTATIONS = [
  ORIENTATION_RIGHT_TO_LEFT,
  ORIENTATION_BOTTOM_TO_TOP,
  ORIENTATION_LEFT_TO_RIGHT,
  ORIENTATION_TOP_TO_BOTTOM
];
export const LEAF_PADDING = 20;
export const NODE_TYPE_SUBSTANCE = 'Substance';
export const NODE_TYPE_LINK = 'Link';
